import React, { Fragment, useState } from 'react';
import {
  RenderTextField,
  required,
} from '../../../../../../components/FormElements/FormikElements';
import styled from 'styled-components';
import { Formik, Form, Field } from 'formik';
import { Box, Collapse, makeStyles, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { TooltipIcon } from '../../../../../../components/Icon';
import ChevronUpIcon from '../../../../../../components/Icon/ChevronUpIcon';
import ChevronDownIcon from '../../../../../../components/Icon/ChevronDownIcon';
import {
  Title,
  TitleAndCollapseButton,
  Card,
  FormWrapper,
  FieldWrapper,
  Headline,
} from '../../AddressAndDetails/components/styles';

const ProviderName = styled.div`
  font-weight: 600;
  text-transform: capitalize;
`;
const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '1rem',
    padding: '10px 14px',
  },
}));

const PaymentIntegrationForm = ({
  businessId,
  paymentIntegrationSchema,
  initialValues,
  handleSubmit,
  deactivateSection,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [confirmCancelModalIsVisible, setConfirmCancelModalIsVisible] =
    useState(false);
  const classes = useStyles();

  return (
    <Card disabled={businessId && !deactivateSection ? false : 'true'}>
      <Formik initialValues={initialValues} enableReinitialize={true}>
        {({ values, handleReset, dirty, isValid, setFieldValue }) => (
          <Fragment>
            <TitleAndCollapseButton>
              <Title
                style={{ textTransform: 'capitalize' }}
                disabled={businessId && !deactivateSection ? false : 'true'}
              >
                Integrations
              </Title>
              {!isExpanded ? (
                <ChevronDownIcon
                  disabled={businessId && !deactivateSection ? false : true}
                  style={{
                    opacity: businessId && !deactivateSection ? 'none' : '0.5',
                  }}
                  onClick={() => {
                    setIsExpanded(true);
                  }}
                />
              ) : (
                <ChevronUpIcon
                  disabled={dirty}
                  onClick={() => {
                    setIsExpanded(false);
                  }}
                />
              )}
            </TitleAndCollapseButton>
            <Collapse in={isExpanded}>
              <Form>
                <FormWrapper>
                  <FieldWrapper grid='1fr 1fr 1.5fr 2fr'>
                    <Headline>Payment Type</Headline>
                    <Headline>Provider</Headline>
                  </FieldWrapper>
                  {values?.credit_card && (
                    <FieldWrapper grid='1fr 1fr 1.5fr 2fr'>
                      <div>Credit Card</div>
                      <ProviderName>{values.credit_card.provider}</ProviderName>
                      {paymentIntegrationSchema?.credit_card[
                        values.credit_card.provider
                      ]?.map((config, index) => {
                        return (
                          <Field
                            key={index}
                            name={`credit_card.configuration.${config.name}`}
                            component={RenderTextField}
                            label={
                              /^sub/.test(config.name)
                                ? `${config.name
                                    .split('_')
                                    .join(' ')
                                    .slice(3)} *`
                                : `${config.name.split('_').join(' ')} *`
                            }
                            validate={required}
                            disabled={true}
                          />
                        );
                      })}
                    </FieldWrapper>
                  )}
                  {values?.gift_card && (
                    <FieldWrapper grid='1fr 1fr 1fr 2fr'>
                      <div>Gift Card</div>
                      <ProviderName>{values.gift_card.provider}</ProviderName>
                      {paymentIntegrationSchema.gift_card[
                        values.gift_card.provider
                      ].map((config, index) => {
                        return (
                          <Field
                            key={index}
                            name={`gift_card.configuration.${config.name}`}
                            component={RenderTextField}
                            label={`${config.name.split('_').join(' ')} *`}
                            validate={required}
                            disabled={true}
                          />
                        );
                      })}
                    </FieldWrapper>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px 16px',
                      borderTop: '1px solid #eee',
                    }}
                  >
                    <Tooltip
                      title='This section is read-only. Please contact support@smooth.tech to make any updates in this section.'
                      arrow
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <span>
                        <TooltipIcon
                          style={{
                            color: '#2440AE',
                            fontSize: '1.5rem',
                          }}
                        />
                      </span>
                    </Tooltip>
                    <Typography
                      variant='body2'
                      style={{ marginLeft: 8, fontSize: '1rem' }}
                    >
                      Need updates here? Contact support@smooth.tech
                    </Typography>
                  </Box>
                </FormWrapper>
              </Form>
            </Collapse>
          </Fragment>
        )}
      </Formik>
    </Card>
  );
};

export default PaymentIntegrationForm;
